import { PageShell, PolicySection } from "@/components/PageShell";

export default function RefundPolicy() {
  return (
    <PageShell
      title="Refund & Cancellation Policy"
      testid="refund-policy-page"
      subtitle="How Findivine reviews and handles refund and cancellation requests for online donations. Last updated: July 2026."
    >
      <PolicySection title="1. Nature of donations">
        <p>
          Donations made to <strong>Findivine</strong> (One Kind Earth Foundation) are voluntary contributions
          towards our social welfare objectives — they are not purchases of goods or services. Once a donation is
          successfully processed, it is generally treated as final. However, we genuinely review requests involving
          errors or unauthorised use, as described below.
        </p>
      </PolicySection>

      <PolicySection title="2. When you can request a review">
        <p>You can ask us to review a donation transaction if:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>the donation was made accidentally, or for an incorrect amount;</li>
          <li>the transaction was unauthorised or fraudulent;</li>
          <li>the same donation was charged more than once (duplicate transaction);</li>
          <li>the payment failed or is pending, but the amount was debited from your account.</li>
        </ul>
        <p>Please contact us as soon as possible after the transaction so we can verify it with the payment provider.</p>
      </PolicySection>

      <PolicySection title="3. How to request a refund or review">
        <p>
          Write to us at{" "}
          <a href="mailto:info@findivine.org" className="text-primary underline underline-offset-2">info@findivine.org</a>{" "}
          or call{" "}
          <a href="tel:+918875285537" className="text-primary underline underline-offset-2">+91 8875285537</a>{" "}
          with the following information:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>your full name;</li>
          <li>the transaction reference, order ID or UPI reference (UTR) number;</li>
          <li>the date and amount of the donation;</li>
          <li>the email address and phone number used while donating;</li>
          <li>a brief description of the issue.</li>
        </ul>
      </PolicySection>

      <PolicySection title="4. How we review requests">
        <p>
          We verify each request against our donation records and the records of the payment gateway or UPI
          provider. We will communicate our decision to you by email or phone. Approved refunds are processed back
          through the payment provider to the original payment method, where supported.
        </p>
        <p>
          The time taken for a refunded amount to appear in your account depends on your bank or payment provider
          and can take several business days after processing. We will share the refund reference with you once it
          is initiated.
        </p>
      </PolicySection>

      <PolicySection title="5. Monthly donations">
        <p>
          If you have set up a monthly donation and wish to stop future deductions, contact us using the details
          below and we will arrange cancellation of the recurring instruction with the payment provider. Amounts
          already deducted are handled under the review process above.
        </p>
      </PolicySection>

      <PolicySection title="6. Pending transactions and receipts">
        <p>
          If a transaction is stuck, you are unsure whether your donation reached us, or you have not received an
          acknowledgement, contact us — we will check the status and assist with confirmation or a receipt.
        </p>
      </PolicySection>

      <PolicySection title="7. Refund contact">
        <p>
          Findivine — One Kind Earth Foundation
          <br />
          Vaishali Nagar, Jaipur, Rajasthan 302021
          <br />
          Email: <a href="mailto:info@findivine.org" data-testid="refund-email" className="text-primary underline underline-offset-2">info@findivine.org</a>
          <br />
          Mobile: <a href="tel:+918875285537" data-testid="refund-phone" className="text-primary underline underline-offset-2">+91 8875285537</a>
        </p>
      </PolicySection>
    </PageShell>
  );
}
